import {call, put, takeLatest, delay} from 'redux-saga/effects'
import {actions} from './action'
import {actionTypes} from './constants'
import {ResponseModel} from 'src/cms/helpers/Models/ResponseModel'
import {service} from './service'
import {ActionModel} from 'src/cms/helpers/Models/ActionModel'
import {globalActionTypes} from 'src/app/modules/errors/redux/constants'

//Get Appointment Status saga
function* getAppointmentStatusSaga(action: ActionModel) {
  try {
    const params: any = action.payload?.params
    yield delay(500)
    const response: ResponseModel = yield call(service.getAppointmentStatus, params)
    const data: any = response?.data
    yield put(actions.getAppointmentStatusSuccess(data))
  } catch (error: any) {
    yield put(actions.getAppointmentStatusError(error))
  }
}

export function* saga() {
  yield takeLatest(actionTypes.GET_APPOINTMENT_STATUS_START, getAppointmentStatusSaga)
}
